
jQuery('.btn_wpp').click(function () { 
    const numbers = jQuery(this).attr('numbers').split(',');
    const msg = jQuery(this).attr('msg');
    
    // Gere um número aleatório com base na lista de números
    const telRand = limparNumeroCelular(pegarValorAleatorio(numbers));
    
    // Gere o link do WhatsApp com o número aleatório e a mensagem
    const link_wpp = generateWhatsAppLink(telRand, msg);
    
    // Atualize o atributo href do link com o novo link do WhatsApp
    jQuery(this).attr('href', link_wpp);
});



function limparNumeroCelular(numeroCelular) {
    // Usa uma expressão regular para remover todos os caracteres não numéricos
    return numeroCelular.replace(/\D/g, '');
}

function pegarValorAleatorio(arr) {
    // Gere um índice aleatório entre 0 e o comprimento do array - 1
    var indiceAleatorio = Math.floor(Math.random() * arr.length);
  
    // Use o índice aleatório para acessar o valor no array
    var valorAleatorio = arr[indiceAleatorio];
  
    return valorAleatorio;
}

function generateWhatsAppLink(number, message = '') {
    // Remove caracteres especiais e espaços do número de telefone
    const cleanedNumber = number.replace(/[+\s]/g, '');
  
    // Constrói o link base do WhatsApp
    let whatsappLink = 'https://wa.me/55';
  
    // Adiciona o número de telefone limpo ao link
    whatsappLink += cleanedNumber;
  
    // Adiciona a mensagem, se fornecida
    if (message) {
      whatsappLink += '?text=' + encodeURIComponent(message);
    }
  
    return whatsappLink;
  }